'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    CDN: '//cdn.ckeditor.com/4.15.1/standard/ckeditor.js',
    types: {
        MINIMAL: {
            toolbar: [['Undo', 'Redo', 'Maximize']],
            removeButtons: '',
            entities_processNumerical: 'force',
            removePlugins: 'elementspath,liststyle,tabletools,tableselection,scayt,menubutton,contextmenu,magicline',
            fillEmptyBlocks: false
        },
        LINKS_AND_LISTS: {
            startupFocus: true,
            toolbar: [{
                name: 'basicstyles',
                items: ['Bold', 'Italic', 'Underline', '-', 'RemoveFormat']
            }, {
                name: 'insert',
                items: ['Link', 'Unlink']
            }, {
                name: 'paragraph',
                items: ['NumberedList', 'BulletedList']
            }],
            removeButtons: '',
            linkShowTargetTab: false,
            entities_processNumerical: 'force',
            removePlugins: 'elementspath,liststyle,tabletools,tableselection,scayt,menubutton,contextmenu,magicline',
            fillEmptyBlocks: false
        },
        LINKS: {
            startupFocus: true,
            toolbar: [{
                name: 'basicstyles',
                items: ['Bold', 'Italic', 'Underline', '-', 'RemoveFormat']
            }, {
                name: 'insert',
                items: ['Link', 'Unlink']
            }],
            removeButtons: '',
            linkShowTargetTab: false,
            entities_processNumerical: 'force',
            removePlugins: 'elementspath,liststyle,tabletools,tableselection,scayt,menubutton,contextmenu,magicline',
            fillEmptyBlocks: false
        },
        BASIC: {
            toolbar: [{
                name: 'basicstyles',
                items: ['Bold', 'Italic', 'Underline', '-', 'RemoveFormat']
            }, {
                name: 'clipboard',
                items: ['Cut', 'Copy', 'Paste', 'PasteFromWord', '-']
            }, {
                name: 'insert',
                items: ['Link', 'Unlink', 'Table', 'HorizontalRule']
            }, {
                name: 'paragraph',
                items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent']
            }, {
                name: 'tools',
                items: ['Format', 'Undo', 'Redo', 'Maximize']
            }],
            removeButtons: '',
            entities_processNumerical: 'force',
            removePlugins: 'elementspath,liststyle,tabletools,tableselection,scayt,menubutton,contextmenu,magicline',
            fillEmptyBlocks: false
        },
        BASIC_WITHOUT_TABLE: {
            toolbar: [{
                name: 'basicstyles',
                items: ['Bold', 'Italic', 'Underline', '-', 'RemoveFormat']
            }, {
                name: 'clipboard',
                items: ['Cut', 'Copy', 'Paste', 'PasteFromWord', '-']
            }, {
                name: 'insert',
                items: ['Link', 'Unlink', 'HorizontalRule']
            }, {
                name: 'paragraph',
                items: ['-', 'Outdent', 'Indent']
            }, {
                name: 'tools',
                items: ['Format', 'Undo', 'Redo', 'Maximize']
            }],
            removeButtons: '',
            entities_processNumerical: 'force',
            removePlugins: 'elementspath,liststyle,tabletools,tableselection,scayt,menubutton,contextmenu,magicline',
            fillEmptyBlocks: false
        },
        DEFAULT: undefined
    }
};
//# sourceMappingURL=ckeditor-config.js.map